<!-- 设备履历 -->
<style scoped="scoped" lang="scss"></style>
<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/resume/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeimingcheng')">
						<yi_cross_select :max="1" :component="'web_base_equipment_list'"
							:ids.sync="yt.conditions.equipmentId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('shebeiSN')">
						<el-input type="text" v-model="yt.conditions.equipmentSn"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeixinghao')">
						<el-input type="text" v-model="yt.conditions.equipmentModel"></el-input>
					</el-form-item>
					<el-form-item :label="$t('suoshuzuzhi')">
						<yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgId">
						</yi_data_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
			</el-button> -->
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('baoyangxiang', scope.row,'70%')">
							{{$t('baoyangxiang')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
						<el-button v-if="scope.row.status==1" type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/maintain/bill/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 处理无接入时间为0的设备 -->
			<template #jierushijian="scope">
				{{scope.row.installTime!=null?time(scope.row.installTime):''}}
			</template>
			<!-- 冻结列 点检次数 -->
			<template #dianjiancishu="scope">
				<el-button type="text" @click="yt.showEditDialog('dianjiancishu', scope.row,'70%')">
					{{scope.row.checkTimes}}
				</el-button>
			</template>
			<!-- 冻结列 保养次数 -->
			<template #baoyangcishu="scope">
				<el-button type="text" @click="yt.showEditDialog('baoyangcishu', scope.row,'70%')">
					{{scope.row.maintainTimes}}
				</el-button>
			</template>
			<!-- 冻结列 维修次数 -->
			<template #weixiucishu="scope">
				<el-button type="text" @click="yt.showEditDialog('weixiucishu', scope.row,'70%')">
					{{(scope.row.repairTimes)}}
				</el-button>
			</template>
			<template #leijitongdianshijian(xiaoshi)="scope">
				{{(scope.row.onlineTime/3600).toFixed(1)}}

			</template>
			<template #leijiyunxingshijian(xiaoshi)="scope">
				{{(scope.row.runTime/3600).toFixed(1)}}
			</template>
		</yi_curd_table>
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增弹窗 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeimingcheng#')" rexiauired>
						<yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId"></yi_data_select>
					</el-form-item>
					<!-- 保养方式,默认选中,不可修改 ，只做显示，不绑定值，后台默认值为“临时保养”-->
					<el-form-item :label="$t('baoyangfangshi')">
						<el-input type="text" value="linshibaoyang" disabled />
					</el-form-item>
					<el-form-item label="jihuabaoyangshijian" required="required">
						<yi_time_input :time.sync="yt.editObj.planTime" :type="'datetime'"></yi_time_input>
					</el-form-item>
					<el-form-item label="beizhu" required="required">
						<el-input type="textarea" v-model="yt.editObj.remark"></el-input>
					</el-form-item>
					<el-form><span>{{$t('baoyangxiang')}}</span></el-form>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/basic/mould/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
				</span>
			</template>
			<!-- 点检次数 -->
			<template v-if="yt.editObj.action == 'dianjiancishu'">
				<div class="dialog-scroller">
					<check_record :checkRecord="yt.editObj" ref="checkRecord"></check_record>
				</div>
			</template>
			<!-- 保养次数 -->
			<template v-if="yt.editObj.action == 'baoyangcishu'">
				<div class="dialog-scroller">
					<maintenance_record :maintenanceRecord="yt.editObj" ref="maintenanceRecord"></maintenance_record>
				</div>
			</template>
			<!-- 维修次数 -->
			<template v-if="yt.editObj.action == 'weixiucishu'">
				<div class="dialog-scroller">
					<repair_record :repairRecord="yt.editObj" ref="repairRecord"></repair_record>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import check_record from '@@/pages/web/equipment/resume/check_record'
	import maintenance_record from '@@/pages/web/equipment/resume/maintenance_record'
	import repair_record from '@@/pages/web/equipment/resume/repair_record'
	export default {
		name: 'web_equipment_resume_list',
		components: {
			check_record,
			maintenance_record,
			repair_record
		},

		data() {
			return {
				// orgList: [],
				list: [],
				columns: [{
					label: 'shebeimingcheng',
					prop: 'equipmentName',
					fixed: 'left'
				}, {
					label: 'shebeiSN',
					prop: 'equipmentSn',
				}, {
					label: 'shebeixinghao',
					prop: 'equipmentModel',
				}, {
					label: 'suoshuzuzhi',
					prop: 'org.name',
				}, {
					label: 'shebeizhuangtai',
					type: 'tag',
					prop: 'status',
					tags: {
						"3": {
							color: '#F56C6C',
							text: this.$t('guzhang')
						},
						"1": {
							color: '#E6A23C',
							text: this.$t('kongxian')
						},
						"0": {
							color: '#67C23A',
							text: this.$t('yunxing')
						},
						"-1": {
							color: '#969696',
							text: this.$t('lixian')
						}
					},
				}, {
					label: 'jierushijian',
					prop: 'installTime',
					type: 'slot',
				}, {
					label: 'leijitongdianshijian(xiaoshi)',
					type: 'slot',
				}, {
					label: 'leijiyunxingshijian(xiaoshi)',
					type: 'slot',
				}, {
					label: 'shangcibaoyangshijian',
					prop: 'lastMaintainDate',
					type: 'time',
					format: "YYYY-MM-DD"
				}, {
					label: 'yujixiacibaoyangshijian',
					prop: 'nextMaintainDate',
					type: 'time',
					format: "YYYY-MM-DD"
				}, {
					label: 'dianjiancishu',
					type: 'slot',
					width: 80,
					fixed: 'right'
				}, {
					label: 'baoyangcishu',
					type: 'slot',
					width: 80,
					fixed: 'right'
				}, {
					label: 'weixiucishu',
					type: 'slot',
					width: 80,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.get(1);
				// this.getOrgList();
			}, 300)
		},

		methods: {
			time(e) {
				if(e==0){
					return ""
				}
				let date = new Date(e);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
			 let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
			},
			// /* 获取组织架构列表 */
			// async getOrgList() {
			// 	let response = await this.http.get('/web/setting/org/page', {
			// 		params: {
			// 			pageSize: 99999,
			// 		}
			// 	})
			// 	this.orgList = response.data.rows
			// },
		},
	};
</script>
